import React from 'react';

import { Radio, Row, Col } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { I18n } from '@aws-amplify/core';

import { useToggleableRadio } from '@/components/views/Report/KimLhc/hooks';
import { WORK_CONDITION_OPTIONS } from '@/components/views/Report/KimLhc/Constants';

import * as S from './styles';

interface HoldLoadFormItemProps {
	fieldName: NamePath;
}

export function HoldLoadFormItem({ fieldName }: Readonly<HoldLoadFormItemProps>): JSX.Element {
	const handleRadioClick = useToggleableRadio(fieldName);

	return (
		<S.FormItemRow name={fieldName}>
			<Radio.Group>
				<S.RadioOptionsContainer>
					{WORK_CONDITION_OPTIONS.hold_load.map((option) => (
						<Radio key={option.value} value={option.value} onClick={() => handleRadioClick(option.value)}>
							<Row gutter={[0, 4]}>
								<Col span={24}>
									<S.FactorDescriptionHeader>{I18n.get(option.titleKey)}</S.FactorDescriptionHeader>
								</Col>
								<Col span={24}>
									<S.FactorDescriptionText>{I18n.get(option.descriptionKey)}</S.FactorDescriptionText>
								</Col>
							</Row>
						</Radio>
					))}
				</S.RadioOptionsContainer>
			</Radio.Group>
		</S.FormItemRow>
	);
}
